import { z } from 'zod';
import { IInventoryOption } from '../../IInventoryOption';

export const legalTransactionRelationshipRealEstateInventoryOptionSchema =
  z.object({
    Amount: z.number(),
    Description: z.string().nullable(),
    Title: z.string().nonempty(),
    idInventoryOption: z.number(),
    idRealEstate: z.number(),
    idRealEstate_has_InventoryOption: z.number().optional(),
  });

export type ILegalTransactionRelationshipRealEstateInventoryOption = z.infer<
  typeof legalTransactionRelationshipRealEstateInventoryOptionSchema
>;

export const initRealEstateInventoryOption = (
  inventoryOption: IInventoryOption,
  realEstateId: number
): ILegalTransactionRelationshipRealEstateInventoryOption => {
  return {
    idInventoryOption: inventoryOption.idInventoryOption,
    Amount: 1,
    Description: null,
    Title: inventoryOption.InventoryOption,
    idRealEstate: realEstateId,
  };
};
